import get from 'lodash.get';
import memoise from 'memoize-one';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Actions from '../../actions';
import { FETCH_ARTICLES } from '../../constants/actions';
import { IArticle, INewsDetailProps } from '../../definitions/news';
import { trackView } from '../../services/analytics';
import { TAPIRequestCanceller } from '../../services/api';
import './news_article.css';
import Render from './render';

export interface IRequests {
  articles?: TAPIRequestCanceller;
  prevPageRequest?: TAPIRequestCanceller;
  nextPageRequest?: TAPIRequestCanceller;
}

class NewsArticle extends React.Component<INewsDetailProps, any> {
  private requests: IRequests = {};
  private defaultRequestParams = {
    fields: "*",
  };

  private getArticle = memoise((articles: IArticle[], paramsUrl: string) => {
    return articles.filter(a => a.url === paramsUrl);
  });

  get dispatch() {
    return get(this.props, 'dispatch');
  }

  get pathname() {
    return get(this.props, 'location.pathname');
  }

  get articles() {
    return get(this.props, 'articles');
  }

  get matchParamsUrl() {
    return get(this.props, 'match.params.url');
  }

  get article(): IArticle {
    return this.getArticle(this.articles, this.matchParamsUrl)[0];
  }

  componentDidMount() {
    trackView(this.pathname);
    this.requests.articles = this.getRequest();
  }

  componentWillUnmount() {
    const articles = get(this.requests, 'articles');

    if (!!articles) {
      articles.cancel();
    }
  }

  render() {
    return Render.call(this, this.props, this.state);
  }

  private getRequest(params: object = {}) {
    return Actions.get(this.dispatch, FETCH_ARTICLES, {
      ...this.defaultRequestParams,
      ...params
    });
  }
}

const state = ({ articles: { articles } }) => ({
  articles
});

export default withRouter(connect(state)(NewsArticle));



// WEBPACK FOOTER //
// ./src/containers/NewsArticle/index.tsx